import {Component, Input, OnInit} from "@angular/core";
import {EmpresaService} from "../../services/empresa.service";
import {ActivatedRoute} from "@angular/router";
import {ConstantsService} from "../../fidelidade/ConstantsService";

@Component({
  selector: 'app-tela-integracao-keeta',
  templateUrl: './tela-integracao-keeta.component.html',
  styleUrls: ['./tela-integracao-keeta.component.scss']
})
export class TelaIntegracaoKeetaComponent implements OnInit {
  @Input() empresa: any = {};
  sincronizando = false;
  novaIntegracao: any;
  mensagemErro: string;
  authId: string;
  state: string;
  lojasAtivar = [];
  carregando = false;
  constructor(private empresaService: EmpresaService,
              private  activatedRoute: ActivatedRoute, private constantsService: ConstantsService) {
  }

  ngOnInit(): void {
    this.authId = this.activatedRoute.snapshot.queryParams.authId;

    if( this.authId){
      this.carregando = true;
      this.constantsService.empresa$.subscribe( empresa => {
        if(empresa){
          this.empresa = empresa;
          if(!this.empresa.integracoesKeeta.length){
            this.empresaService.obtenhaLojasAtivar(this.authId).then((lojas: any) => {
              this.carregando  = false;
              if(lojas && lojas.length){
                this.novaIntegracaoKeeta(lojas)
              }  else {
                this.mensagemErro  = 'Nenhuma loja retornada para ativaçao'
              }
            }).catch((err) => {
              this.carregando  = false;
              this.mensagemErro = err.message || err;
            })
          }
        } else {
          this.carregando  = false;
        }
       })
    } else {
      if(!this.empresa.integracoesKeeta.length)
        this.novaIntegracaoKeeta()
    }
  }

  novaIntegracaoKeeta(lojasAtivar = null){
    this.novaIntegracao  = { nova: true }
    if(lojasAtivar) this.novaIntegracao.lojasAtivar = lojasAtivar;
    if(this.authId) this.novaIntegracao.authId = this.authId;

  }

  sincronizarFormasPagamentos(){
    this.sincronizando = true;

    this.empresaService.sincronizeFormasPagamentoKeeta().then((res: any) => {
      this.sincronizando = false;
    }).catch( (erro) => {
      this.mensagemErro = erro;
      this.sincronizando = false
      alert(erro)
    })
    return false;
  }
}
